'use client'
import { ActivityIndicator } from 'react-native'
import React from 'react'
import { tva } from '@gluestack-ui/utils/nativewind-utils'
import { cssInterop } from 'nativewind'

import { colors } from '../../tokens'

cssInterop(ActivityIndicator, {
    className: { target: 'style', nativeStyleToProp: { color: true } },
})

const spinnerStyle = tva({})

// AOS redesign (AOS-605): default spinner is the action blue (Figma
// Primary/default #3459C6). For the on-button variant pass
// `color` = content/on-primary (#ECF1F8).
const DEFAULT_SPINNER_COLOR = colors.action.default

// AOS-1130: the loading indicator is 24px everywhere (Figma 9980-37317).
const SPINNER_SIZE = 24

const Spinner = React.forwardRef<
    React.ComponentRef<typeof ActivityIndicator>,
    Omit<React.ComponentProps<typeof ActivityIndicator>, 'size'>
>(function Spinner(
    { className, color, focusable = false, 'aria-label': ariaLabel = 'loading', ...props },
    ref,
) {
    return (
        <ActivityIndicator
            ref={ref}
            focusable={focusable}
            aria-label={ariaLabel}
            {...props}
            size={SPINNER_SIZE}
            color={color ?? DEFAULT_SPINNER_COLOR}
            className={spinnerStyle({ class: className })}
        />
    )
})

Spinner.displayName = 'Spinner'

export { Spinner }
